import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

import { Link, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import './NewSidebarAVAP.css';
import './../NewDashboard.css';
import { Button, Col, Form, Modal, Row, Alert } from 'react-bootstrap';
import ObexRequestHandler from '../../../handlers/ObexRequestsHandler';
// import BasicImgUser from '../../../assets/img/icono.png'; // No longer needed
// import BasicImgUserDark from '../../../assets/img/icono_dark.png'; // No longer needed
import SessionService from '../../../services/SessionsService';
import SupportBanner from '../../../components/DashboardComponents/supportBanner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faCamera, faSearchMinus, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { UpdatedName } from '../../../redux/slices/updateSidebarGreen';
// import { updateName } from '../../../redux/slices/KnowDin';

// funcion para obtener los iniciales de un nombre
const getInitials = (firstName: string | undefined, lastName: string | undefined, email: string | undefined): string => {
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  } else if (firstName) {

    return firstName.length > 1 ? `${firstName.substring(0, 2)}`.toUpperCase() : firstName.charAt(0).toUpperCase();
  } else if (email) {
    const namePart = email.split('@')[0];
    if (namePart.length > 1) {
 
        const parts = namePart.split(/[._-]/);
        if (parts.length > 1) {
            return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
        }
        return `${namePart.charAt(0)}${namePart.charAt(1)}`.toUpperCase();
    } else if (namePart.length === 1) {
     return namePart.charAt(0).toUpperCase();
    }
  }
  return '??'; 
};

const NewSidebarAVAP = () => {
  let { path, url } = useRouteMatch();

  const history = useHistory();
  const [get_personal_info, setGet_personal_info] = useState<any>({});
  // const [showModalImg, setShowModalImg] = useState(false); 
  const [selectedImage, setSelectedImage] = useState(null); 
  const [disabledButtonSendImg, setDisabledButtonSendImg] = useState(false);
  const [errorMsg, setError] = useState('');
  const [isUploading, setIsUploading] = useState(false);


  const [imageToCrop, setImageToCrop] = useState<string | null>(null);
  const [showCropModal, setShowCropModal] = useState(false);

 
  const fileInputRef = useRef<HTMLInputElement>(null);


  const handleClose = () => {
    // setShowModalImg(false);
    setSelectedImage(null); // Clear selection if old modal is closed
    setFilename('Select File');
  };
  const handleClose2 = () => setShowModal2(false);
  const [fileName, setFilename] = useState('Select File')

  const placeAvatar = 'data:image/png;base64,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'

  const isUpdatedName = useSelector((state: any) => state.updateSidebarGreen.name);
  const dispatch = useDispatch();
 
  const [showModal, setShowModal2] = useState(false);

    const [isDarkMode, setIsDarkMode] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        return false; //savedTheme === 'dark';
    });

  const getPersonalInformation = async () => {
    try {
      // debugger
      const result = (await ObexRequestHandler.get('/get_personal_info')).data;
       console.log("sidebar", result);
      setGet_personal_info(result);
      // console.log(result.image);
      


    } catch (error) {
      console.error('ERROR FETCHING PERSONAL INFO ', error);
    }
  }

 
  const changeImg = () => {
    // setShowModalImg(true) 
    fileInputRef.current?.click(); 
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
   
        setImageToCrop(reader.result as string);
        setShowCropModal(true); 
      };
      reader.readAsDataURL(file);
      setFilename(file.name); 
    }

    if(e.target) {
        e.target.value = '';
    }
  };

 
  const handleImageCropped = (croppedImageDataUrl: string) => {
      setSelectedImage(croppedImageDataUrl); 
      setShowCropModal(false);
      handleSubmit(croppedImageDataUrl);
  };

 
  const handleSubmit = async(croppedImageDataUrl: string | null) => {
    if (croppedImageDataUrl) {

      setIsUploading(true);
      setDisabledButtonSendImg(true);
      setError(''); 

  
      const buggyBase64String = btoa(croppedImageDataUrl);
      const payload = { image: buggyBase64String }; 

  
      
      try{
      const result = await ObexRequestHandler.post('/update_avatar', payload);
      
      if(result.success && result.success==true){
        
        setSelectedImage(null);
          setImageToCrop(null);
          setFilename('Select File');
          setShowCropModal(false);
          setDisabledButtonSendImg(false);
          getPersonalInformation(); 
        } else {
       
          setError(result.message || 'Failed to update avatar. Image might be too large or invalid.');
          setDisabledButtonSendImg(false)
        
        }
      } catch (err) {
        console.error("Error uploading avatar:", err);
        setError('An error occurred while uploading. Image might be too large.');
        setDisabledButtonSendImg(false);
    } finally {
         setIsUploading(false); 
         setDisabledButtonSendImg(false); 
    }
      
    } else {
      console.log('No cropped image data to submit');
      setError('Cropping failed or was cancelled.');
      setDisabledButtonSendImg(false);
    }
  };

  const decode_atob =(text)=>{
    const decodedText = atob(text);
    return decodedText;

  } 

  useEffect(() => {
    getPersonalInformation();

  }, [])

  useEffect(() => {
   

    if (isUpdatedName) {
      const timer = setTimeout(() => {
        getPersonalInformation();
        dispatch(UpdatedName(false));
      }, 1000);

      return () => clearTimeout(timer); // Limpia el timeout cuando el componente se desmonta o `isUpdatedName` cambia
    }
  }, [isUpdatedName, dispatch]);

  // Calcula las incialies
  const initials = getInitials(
    get_personal_info?.first_name,
    get_personal_info?.last_name,
    get_personal_info?.email
  );


  return (

    <div className='d-flex flex-column' style={{paddingLeft:'40px', paddingRight:'40px', backgroundColor:'var(--color-surface)', width:'100%'}}>

        <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
            accept="image/png, image/jpeg, image/gif" 
        />

      <div 
         className={`marginTopProfile mb-3 sizeProfile avatar-wrapper ${isUploading ? 'uploading' : ''}`} 
         onClick={!isUploading ? changeImg : undefined}
         style={{cursor: isUploading ? 'progress' : 'pointer'}} 
      > 
        {get_personal_info && get_personal_info.image ? (
          <img className='avatar-image' src={decode_atob(get_personal_info.image)} alt="User Avatar" />
        ) : (
      
          <div className='avatar-initials-container'>
             <span className="avatar-initials">{initials}</span>
          </div>
        )}
      
        <FontAwesomeIcon icon={faCamera} className="avatar-camera-icon" />
      </div>

      <div id='id_owner' style={{ maxHeight:'80px', overflow:'hidden', wordWrap:'break-word', maxWidth:'180px' }} className='textBold colorBlack fontSizeProfile text-center'>
        {get_personal_info && get_personal_info.first_name} {get_personal_info && get_personal_info.middle_name} {get_personal_info && get_personal_info.last_name}
      </div>
      <div className='colorGreen2 mb-4 fontSizeEmail text-center'>
        {get_personal_info && get_personal_info.email}
      </div>



      <div className='d-flex flex-column colorBlack2'>

        <div  style={{ minWidth:'180px' }} className={`mb-3 ${location.pathname === `${url}/personal-information` ? 'active color-activo' : ''}`}>
          <Link to={`${url}/personal-information`} className={`fontSizeLinks ${location.pathname === `${url}/personal-information` ? 'color-activo' : ' colorBlack2 color-activo'}`}>Personal Information</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/sigin-and-security` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/sigin-and-security`} className={`fontSizeLinks ${location.pathname === `${url}/sigin-and-security` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Sign-In and Security</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/licenses-and-suscriptions` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/licenses-and-suscriptions`} className={`fontSizeLinks ${location.pathname === `${url}/licenses-and-suscriptions` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Licenses and Suscriptions</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/licenses-and-downloads` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/licenses-and-downloads`} className={`fontSizeLinks ${location.pathname === `${url}/licenses-and-downloads` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Downloads</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/project-granted` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/project-granted`} className={`fontSizeLinks ${location.pathname === `${url}/project-granted` ? 'active color-activo' : ' colorBlack2 color-activo'}` }>API Projects Granted</Link>
        </div>
        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/licenses-manager` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/licenses-manager`} className={`fontSizeLinks ${location.pathname === `${url}/licenses-manager` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Licenses Manager</Link>
        </div>
        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/payments` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/payments`} className={`fontSizeLinks ${location.pathname === `${url}/payments` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Payment Methods</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/billing` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <Link to={`${url}/billing`} className={`fontSizeLinks ${location.pathname === `${url}/billing` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Billing</Link>
        </div>

        <div  style={{minWidth:'180px'}} className={`mb-3 ${location.pathname === `${url}/personal-information-tutorial` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>
          <div style={{cursor:'pointer'}} onClick={()=>{
            SessionService.TUTORIAL_SHOWED_ID= false; 
            if (window.location.pathname ==='/dashboard/personal-information') 
            {window.location.replace('/dashboard/personal-information');} 
            else 
            {
              history.push('/dashboard/personal-information')
              }
            }
            } className={`fontSizeLinks ${location.pathname === `${url}/personal-information-tutorial` ? 'active color-activo' : ' colorBlack2 color-activo'}`}>Tutorial</div>
        </div>

        <div  style={{minWidth:'180px'}} className={`${location.pathname === `${url}/login` ? 'active' : ''}`}>
          <div style={{cursor:'pointer'}} onClick={()=>{setShowModal2(true)}} className="colorBlack2 fontSizeLinks">Sign out</div>
        </div>
        {/* <ul>
          <li>
            <Link to={`${url}/personal-information`}>Personal Information</Link>
          </li>
          <li>
            <Link to={`${url}/sigin-and-security`}>Sign-In and Security</Link>
          </li>
          <li>
            <Link to={`${url}/licenses-and-downloads`}>Licenses and Downloads</Link>
          </li>
          <li>
            <Link to={`${url}/project-granted`}>Project Granted</Link>
          </li>
          <li>
            <Link to={`${url}/payments-and-billing`}>Payments & Billing</Link>
          </li>
          <li>
            <Link to={`${url}/privacy`}>Privacy</Link>
          </li>
        </ul> */}

      </div>


      {/* MODAL BEGIN */}




      <Modal style={{ marginTop:'0rem', paddingTop:'7em' }} show={showModal} onHide={handleClose2} container={document.getElementById('avapIdWrapper')}>
        <Modal.Body className='colorBlack'>Do you want to sign out?</Modal.Body>
        <Modal.Footer>
          <button className="btn custom-button  textBold" onClick={() => history.push('/login')}>
            Yes
          </button>

          <button className="btn custom-button textBold" onClick={handleClose2}>
            No
          </button>
          
        </Modal.Footer>
      </Modal>



      
    
      {/* <Modal style={{ marginTop:'0rem' }} show={showModalImg} onHide={handleClose} id="modalImg" dialogClassName="addons-dialog w-75 obex-dialog">
        <Modal.Header closeButton className="border-0 pb-0">
          <Col style={{ textAlign:'center' }}>
          <Modal.Title  className='fontSizeTitleCard textBold' style={{fontSize:'1.5rem', color:'black'}}>Select an image for your avatar</Modal.Title>
          </Col>
        </Modal.Header>
        <Modal.Body className=''>
          <Form >
            <Row>
              <Col style={{ marginLeft:'20px', marginRight:'20px', borderColor:'lightgray', borderStyle:'solid', borderWidth:'1px', borderRadius:'9px' }}>
            <Form.Group  controlId="formFile" className='m-0'>

              <label htmlFor="file-upload" className="btn custom-button textBold" style={{ margin:'20px' }}>
        Select a new Image
              </label>
    
        <input id="file-upload" type="file" accept='image/*' className='btn custom-button input-field ' hidden 
                onChange={handleFileChange}
              />
              <span className='fontSizeTitleCard ' style={{ color:'black', position:'absolute', marginTop:'23px' }}>{fileName}</span>

            </Form.Group>
            </Col>
            </Row>
              <div style={{maxHeight:'300px', overflow:'hidden'}} className='d-flex justify-content-center align-items-center'>
                <img src={selectedImage == undefined ? placeAvatar : selectedImage} alt="Preview" style={{ maxHeight:'300px', aspectRatio:'auto ', paddingTop:'20px', maxWidth: '30%', marginTop: '40px', marginBottom:'40px' }} />
              </div>
            
          </Form>
          { errorMsg!='' && <Alert variant='danger'>{errorMsg}</Alert> }
          
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-center w-100'>
            <button className="btn custom-button textBold" onClick={handleSubmit} disabled={disabledButtonSendImg}>Save</button>
          </div>
        </Modal.Footer>
      </Modal> */}

       {showCropModal && imageToCrop && (
          <ImageCropModal
              show={showCropModal}
              imageSrc={imageToCrop}
              onHide={() => {
                  setShowCropModal(false);
                  setImageToCrop(null); 
                  setFilename('Select File');
              }}
              onCropComplete={handleImageCropped}
              aspectRatio={1} //aspecto de la imagen
              outputWidth={200} // ancho de la imagen final
          />
       )}


    </div>
  )
}


interface ImageCropModalProps {
    show: boolean;
    imageSrc: string;
    onHide: () => void;
    onCropComplete: (croppedImageDataUrl: string) => void;
    aspectRatio?: number;
    outputWidth?: number; 
}

const ImageCropModal: React.FC<ImageCropModalProps> = ({ show, imageSrc, onHide, onCropComplete, aspectRatio = 1, outputWidth = 200 }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const previewCanvasRef = useRef<HTMLCanvasElement>(null); 
    const imageRef = useRef<HTMLImageElement>(new Image());
    const [scale, setScale] = useState(1);
    const [[offsetX, offsetY], setOffset] = useState([0, 0]);
    const [[startX, startY], setStart] = useState([0, 0]);
    const [isDragging, setIsDragging] = useState(false);

    const cropSize = 250; // tamaño del area de corte en el modal
    const modalWidth = 500; // ancho del modal
    const previewSize = 80; // tamaño del cuadrado de la imagen

  
    const outputHeight = Math.round(outputWidth / aspectRatio);

 
    const getCropCenter = (): [number, number] => {
        return [modalWidth / 2, cropSize / 2];
    };

    
    useEffect(() => {
        if (imageSrc && show) {
            imageRef.current.onload = () => {
                const img = imageRef.current;
                const canvas = canvasRef.current;
                if (!canvas) return;

                // Reset state for new image
                const hRatio = cropSize / img.naturalWidth;
                const vRatio = cropSize / img.naturalHeight;
                const initialScale = Math.max(hRatio, vRatio); 

                setScale(initialScale);

                
                const initialOffsetX = (modalWidth - img.naturalWidth * initialScale) / 2;
                const initialOffsetY = (cropSize - img.naturalHeight * initialScale) / 2;
                setOffset([initialOffsetX, initialOffsetY]);
            };
            imageRef.current.onerror = () => {
                console.error("Failed to load image for cropping.");
                onHide();
            };
            imageRef.current.crossOrigin = "anonymous";
            imageRef.current.src = imageSrc;
        } else if (!show) {
            '';
        }
    }, [imageSrc, show, onHide]);

   
    useEffect(() => {
        const img = imageRef.current;
        const canvas = canvasRef.current;
        if (!canvas || !img.complete || img.naturalWidth === 0) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        drawCanvas(ctx, img, scale, offsetX, offsetY);
        drawPreviewCanvas();
    }, [scale, offsetX, offsetY, imageSrc, show]);

    const drawCanvas = (ctx: CanvasRenderingContext2D, img: HTMLImageElement, currentScale: number, currentOffsetX: number, currentOffsetY: number) => {
        const canvas = ctx.canvas;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

       
        ctx.drawImage(img, currentOffsetX, currentOffsetY, img.naturalWidth * currentScale, img.naturalHeight * currentScale);

       
        ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
        const cropX = (canvas.width - cropSize) / 2;
        const cropY = 0; 

       
        ctx.fillRect(0, 0, canvas.width, cropY); 
        ctx.fillRect(0, cropY + cropSize, canvas.width, canvas.height - (cropY + cropSize));
        ctx.fillRect(0, cropY, cropX, cropSize); 
        ctx.fillRect(cropX + cropSize, cropY, canvas.width - (cropX + cropSize), cropSize); 

        
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)';
        ctx.lineWidth = 1;
        ctx.strokeRect(cropX, cropY, cropSize, cropSize);
    };

  
    const drawPreviewCanvas = () => {
        const img = imageRef.current;
        const previewCanvas = previewCanvasRef.current;
        if (!previewCanvas || !img.complete || img.naturalWidth === 0) return;
        const previewCtx = previewCanvas.getContext('2d');
        if (!previewCtx) return;

        previewCtx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);

      
        const cropVisualX = (modalWidth - cropSize) / 2;
        const cropVisualY = 0;
        const sourceX = (cropVisualX - offsetX) / scale;
        const sourceY = (cropVisualY - offsetY) / scale;
        const sourceWidth = cropSize / scale;
        const sourceHeight = cropSize / scale;

     
        previewCtx.drawImage(
            img,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            0,
            0,
            previewSize,
            previewSize / aspectRatio 
        );
    };

  
    const handleInteractionStart = (clientX: number, clientY: number) => {
        setIsDragging(true);
        setStart([clientX, clientY]);
    };
    const handleMouseDown = (e: React.MouseEvent<HTMLCanvasElement>) => {
        e.preventDefault();
        handleInteractionStart(e.clientX, e.clientY);
    };
    const handleTouchStart = (e: React.TouchEvent<HTMLCanvasElement>) => {
         if (e.touches.length === 1) {
            e.preventDefault();
            handleInteractionStart(e.touches[0].clientX, e.touches[0].clientY);
         }
    };

    // Mouse/Touch Move
    const handleInteractionMove = (clientX: number, clientY: number) => {
         if (!isDragging) return;
        const deltaX = clientX - startX;
        const deltaY = clientY - startY;
        setOffset([offsetX + deltaX, offsetY + deltaY]);
        setStart([clientX, clientY]);
    };
    const handleMouseMove = (e: React.MouseEvent<HTMLCanvasElement>) => {
        e.preventDefault();
        handleInteractionMove(e.clientX, e.clientY);
    };
     const handleTouchMove = (e: React.TouchEvent<HTMLCanvasElement>) => {
        if (e.touches.length === 1) {
            e.preventDefault();
            handleInteractionMove(e.touches[0].clientX, e.touches[0].clientY);
        }
    };

    // Mouse/Touch Up
    const handleInteractionEnd = () => {
        if (isDragging) {
            setIsDragging(false);
        }
    }
    const handleMouseUp = (e: React.MouseEvent<HTMLCanvasElement>) => {
        e.preventDefault();
        handleInteractionEnd();
    };
     const handleTouchEnd = (e: React.TouchEvent<HTMLCanvasElement>) => {
        e.preventDefault();
        handleInteractionEnd();
    };

   
    const handleZoomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newScale = parseFloat(e.target.value);
        const img = imageRef.current;
        if (!img.complete || img.naturalWidth === 0) return;

        const [cx, cy] = getCropCenter();

       
        const imgX = (cx - offsetX) / scale;
        const imgY = (cy - offsetY) / scale;

      
        const newOffsetX = cx - imgX * newScale;
        const newOffsetY = cy - imgY * newScale;

        setScale(newScale);
        setOffset([newOffsetX, newOffsetY]);
    };

  
    const handleCrop = () => {
        const img = imageRef.current;
        if (!img.complete || img.naturalWidth === 0) {
            console.error("Cannot crop, image not ready");
            return;
        }

        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = outputWidth;
        tempCanvas.height = outputHeight;
        const tempCtx = tempCanvas.getContext('2d');
        if (!tempCtx) {
             console.error("Cannot get context for cropping");
            return;
        }

     
        const cropVisualX = (modalWidth - cropSize) / 2;
        const cropVisualY = 0;
        const sourceX = (cropVisualX - offsetX) / scale;
        const sourceY = (cropVisualY - offsetY) / scale;
        const sourceWidth = cropSize / scale;
        const sourceHeight = cropSize / scale;

       
        tempCtx.drawImage(
            img,
            sourceX, sourceY,
            sourceWidth, sourceHeight,
            0, 0,
            outputWidth, outputHeight
        );

      
        const croppedImageDataUrl = tempCanvas.toDataURL('image/png');
        onCropComplete(croppedImageDataUrl);
    };



    const [minZoom, setMinZoom] = useState(0.1);
    useEffect(() => {
        const img = imageRef.current;
        if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
             const hRatio = cropSize / img.naturalWidth;
             const vRatio = cropSize / img.naturalHeight;
             setMinZoom(Math.max(hRatio, vRatio)); 
        }
    }, [imageSrc, show]); 

    const maxZoom = 3;

    return (
        <Modal id='modalImg' show={show} onHide={onHide} centered dialogClassName="image-crop-dialog" size="lg"
         container={document.getElementById('avapIdWrapper')}
        > 
            <Modal.Header closeButton>
                <Modal.Title>Adjust Your Photo</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: 'center', padding: '1rem', overflow: 'hidden' }}>
               
                <div style={{ width: `${modalWidth}px`, height: `${cropSize}px`, margin: 'auto', overflow: 'hidden', position: 'relative' }}>
                    <canvas
                        ref={canvasRef}
                        width={modalWidth}
                        height={cropSize}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        style={{ cursor: isDragging ? 'grabbing' : 'grab', position: 'absolute', top: 0, left: 0 }}
                    />
                </div>

                  {/* Zoom Controls */} 
                  <div className="d-flex align-items-center w-50 mb-3" style={{ margin:'auto', marginTop:'20px' }}>
                 
                    <FontAwesomeIcon icon={faSearchMinus} style={{ marginRight: '10px', opacity: 0.7, transform: 'scale(1.2)'}} />
                    <Form.Control
                         type="range"
                         min={minZoom}
                         max={maxZoom}
                         step="0.01"
                         value={scale}
                         onChange={handleZoomChange}
                         style={{ flexGrow: 1 }}
                         disabled={!imageSrc || !imageRef.current.complete}
                    />
                  
                    <FontAwesomeIcon icon={faSearchPlus} style={{ marginLeft: '10px', opacity: 0.7, transform: 'scale(1.2)'}}/>
                </div>

                {/* Preview Area */}
                 <div className="mb-3 text-center">
                     <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Preview</div>
                     <canvas
                        ref={previewCanvasRef}
                        width={previewSize}
                        height={previewSize / aspectRatio} 
                        style={{ border: '1px solid #ccc', borderRadius: aspectRatio === 1 ? '50%' : '0' }} 
                     />
                 </div>
            </Modal.Body>
             <Modal.Footer className="d-flex flex-column align-items-center">
              

       
                <div className="d-flex justify-content-between w-100 mt-3">
                 <button className="btn customButton-ln-green textBold txt-green-ptl" style={{ width: '200px' }} onClick={onHide}>
                    Cancel
                </button>
                <Button className="btn customButton-green textBold" style={{ width: '200px' }} onClick={handleCrop} disabled={!imageSrc || !imageRef.current.complete}>
                    Upload
                </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default NewSidebarAVAP;